module.exports = __webpack_public_path__ + "img/Professional-5.6b6fedda.png";